import React, { useContext, useState } from 'react';
import { ToastContext } from 'app/context/ToastContext';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import axios from 'axios';

export const ChangePasswordPage = () => {
  const { showSuccess, showError } = useContext(ToastContext);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [repeatNewPassword, setRepeatNewPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSave = e => {
    e.preventDefault();

    if (newPassword !== repeatNewPassword) {
      showError('Chyba', 'Nové heslo a zopakovanie hesla nie sú rovnaké.');
      return;
    }

    const data = {
      currentPassword: oldPassword,
      newPassword,
    };

    setLoading(true);

    axios
      .post('/api/account/change-password', data)
      .then(r => {
        setOldPassword('');
        setNewPassword('');
        setRepeatNewPassword('');
        showSuccess('Úspech', 'Heslo bolo úspešne zmenené.');
      })
      .catch(error => {
        console.error(error);
        showError('Chyba', error.response?.data?.detail);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="d-flex align-items-center justify-content-center vh-80">
      <div className="card p-4" style={{ width: '350px' }}>
        <h4 className="text-center mb-4">Zmena hesla</h4>
        <form onSubmit={handleSave}>
          {/* Old Password */}
          <div className="mb-3">
            <label htmlFor="oldPassword" className="form-label">
              Staré heslo
            </label>
            <InputText
              id="oldPassword"
              type="password"
              value={oldPassword}
              onChange={e => setOldPassword(e.target.value)}
              className="w-100"
            />
          </div>

          {/* New Password */}
          <div className="mb-3">
            <label htmlFor="newPassword" className="form-label">
              Nové heslo
            </label>
            <InputText
              id="newPassword"
              type="password"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              className="w-100"
            />
          </div>

          {/* Repeat New Password */}
          <div className="mb-4">
            <label htmlFor="repeatNewPassword" className="form-label">
              Zopakujte heslo
            </label>
            <InputText
              id="repeatNewPassword"
              type="password"
              value={repeatNewPassword}
              onChange={e => setRepeatNewPassword(e.target.value)}
              className="w-100"
            />
          </div>

          {/* Save Button */}
          <Button
            icon={loading ? 'pi pi-spin pi-spinner' : ''}
            disabled={loading}
            label="Zmeniť heslo"
            type="submit"
            className="w-100 p-button-outlined"
          />
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordPage;
